module.exports = __webpack_public_path__ + "static/img/core-bg-03.b75538c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/core-bg-03.png
// module id = bVhP
// module chunks = 1